import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgZorroAntdModule } from "../../modules/nz-zorro-antd.module";
import { NgZorroIconModule } from "../../modules/nz-icon-antd.module";
import { I18nService } from "../../services/i18n.service";
import { HeaderComponent } from "./header.component";
import { TranslateModule } from "@ngx-translate/core";
import { LanguageNavbarModule } from "../../pages/shared-component/dashboard-navbar/language-navbar/language-navbar.module";

@NgModule( {
    declarations: [ HeaderComponent ],
    imports: [ CommonModule, NgZorroAntdModule, NgZorroIconModule, TranslateModule, LanguageNavbarModule ],
    exports: [ HeaderComponent ],
    providers: [ I18nService ]
} )
export class HeaderModule {}
